import firebase from "firebase";
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import DocumentData = firebase.firestore.DocumentData;
import {Location} from "@/store/modules/Locations/LocationEntitiy";

export default class LocationFactory {

    public static makeByFirestoreSnapshot(snapshot: QuerySnapshot<DocumentData>): Location[] {
        return snapshot.docs.map(v => {
            const location = Object.assign({id: v.id}, v.data()) as Location;
            console.log(v.data().date)
            location.date = new Date( v.data().date);
            return location;
        });
    }

}


